<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="标题">
              <a-input
                v-model="queryParam.title"
                placeholder="请输入"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="类型">
              <a-select v-model="queryParam.type" placeholder="请选择类型">
                <a-select-option
                  v-for="item in typeList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table -->
    <div>
      <a-button
        type="primary"
        icon="plus"
        @click="addAdvisory"
        style="margin-bottom:20px"
        >新增</a-button
      >
      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :rowKey="r => r.id"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="showLook(record)">查看</a>
          <a-divider type="vertical" />
          <a @click="showEdit(record)">编辑</a>
          <!-- <a-divider type="vertical" />
          <a @click="showmodal(record)">传播链路</a> -->
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <a-modal :visible="show" @ok="showOk" @cancel="showOk">
      <div class="">{{ title }}</div>
      <a v-if="conurl" :href="conurl" target="_Blank">{{ conurl }}</a>
      <div v-else v-html="content"></div>
    </a-modal>
    <advisory-modal
      ref="advisoryModal"
      :visible="visible"
      @cancle="cancle"
    ></advisory-modal>
  </a-card>
</template>

<script>
const typeList = [
  {
    id: 1,
    name: '资讯'
  },
  {
    id: 2,
    name: '活动'
  }
];
import advisoryModal from './advisoryModal';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'examineList',
  mixins: [JeecgListMixin],
  components: {
    advisoryModal
  },

  data() {
    return {
      columns: [
        {
          title: '标题',
          align: 'center',
          dataIndex: 'title'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'create_time'
        },
        {
          title: '类型',
          align: 'center',
          dataIndex: 'type',
          width: 100,
          customRender: function(text, record, index) {
            if (text === 1) {
              return '资讯';
            } else if (text == 2) {
              return '活动';
            }
          }
        },
        {
          title: '操作',
          width: 200,
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }
      ],
      conurl: '',
      loading: false,
      visible: false,
      url: {
        list: 'course-biz/zx/findZx'
      },
      content: '',
      title: '',
      show: false,
      typeList
    };
  },
  computed: {},
  methods: {
    addAdvisory() {
      this.visible = true;
      this.$refs.advisoryModal.content = '';
      this.$refs.advisoryModal.title = '';
      this.$refs.advisoryModal.status = 0;
      this.$refs.advisoryModal.id = '';
      this.$refs.advisoryModal.url = '';
      this.$refs.advisoryModal.typeValue = 1;
      this.$refs.advisoryModal.conValue = 1;
    },
    modalOk() {
      this.visible = false;
      this.loadData(1);
    },
    cancle() {
      this.visible = false;
      this.loadData();
    },
    showOk() {
      this.show = false;
    },
    showLook(e) {
      console.log(e);
      this.show = true;
      this.content = e.content;
      this.title = e.title;
      this.conurl = e.url;
    },
    showEdit(e) {
      this.visible = true;
      this.$refs.advisoryModal.formData.content = e.content;
      this.$refs.advisoryModal.formData.title = e.title;
      this.$refs.advisoryModal.formData.status = 1;
      this.$refs.advisoryModal.formData.id = e.id;
      this.$refs.advisoryModal.formData.url = e.url;
      this.$refs.advisoryModal.formData.typeValue = e.type;
      this.$refs.advisoryModal.status = 1;
    }
  },
  mounted() {}
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
